<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="dashboard-container">
  <mat-card class="header-card">
    <div class="header">
      <div class="title-section">
        <div class="title">Tournament: {{ this.tournamentOverview?.name }}</div>
        <div class="description">Description: {{ this.tournamentOverview?.description }}</div>
      </div>
      <div class="details-section">
        <div>Max allowed participants: {{ this.tournamentOverview?.maxParticipants }}</div>
        <div>End of registration: {{ this.registrationEndAsDate | date: 'short' }}</div>
      </div>
      <div class="button-container">
        <button mat-flat-button color="primary" routerLink="/admin/tournaments">All Tournaments</button>
        <button
          mat-flat-button
          color="primary"
          [routerLink]="['/admin/tournaments', this.tournamentId(), 'edit']"
        >
          Edit
        </button>
        <button
          mat-flat-button
          color="tertiary"
          [routerLink]="['/admin/tournaments', this.tournamentId(), 'pictures']"
        >
          Pictures
        </button>
      </div>
    </div>
  </mat-card>

  <div class="cards">
    <div class="hover-transform">
      <mat-card class="card" [routerLink]="'teams'">
        <mat-card-title>Teams</mat-card-title>
        <mat-card-content>
          <div>
            Teams: {{ this.tournamentOverview?.teams }} of
            {{ this.tournamentOverview?.maxParticipants }}
            @if (this.tournamentOverview?.teams === this.tournamentOverview?.maxParticipants) {
              <mat-icon inline="true" class="count-checkmark">check</mat-icon>
            }
          </div>
          <div>
            Ready: {{ this.tournamentOverview?.checkedInTeams }} of
            {{ this.tournamentOverview?.teams }}
            @if (
              this.tournamentOverview?.checkedInTeams === this.tournamentOverview?.teams &&
              this.tournamentOverview?.checkedInTeams > 0
            ) {
              <mat-icon inline="true" class="count-checkmark">check</mat-icon>
            }
          </div>
        </mat-card-content>
        <div class="bottom-color-border"></div>
      </mat-card>
    </div>
    <div class="hover-transform">
      <mat-card class="card" [routerLink]="'tables'">
        <mat-card-title>Tables</mat-card-title>
        <mat-card-content>
          <div>Count: {{ this.tournamentOverview?.tables }}</div>
          <div>Used: {{ this.tournamentOverview?.tablesInUse }}</div>
        </mat-card-content>
        <div class="bottom-color-border"></div>
      </mat-card>
    </div>
    <div class="hover-transform">
      <mat-card class="card" [routerLink]="'qualification-phase'">
        <mat-card-title>Qualification-Phase</mat-card-title>
        <mat-card-content>
          <div>Status: {{ qualificationMatchesStatus }}</div>
          <div>Matches to play: {{ this.tournamentOverview?.allQualificationMatches }}</div>
          <div>Matches played: {{ this.tournamentOverview?.playedQualificationMatches }}</div>
        </mat-card-content>
        <div class="bottom-color-border"></div>
      </mat-card>
    </div>
    <div class="hover-transform">
      <mat-card class="card" [routerLink]="'ko-phase'">
        <mat-card-title>K.O.-Phase</mat-card-title>
        <mat-card-content>
          <div>Status: {{ koMatchesStatus }}</div>
          <div>Matches to play: {{ this.tournamentOverview?.allKoMatches }}</div>
          <div>Matches played: {{ this.tournamentOverview?.playedKoMatches }}</div>
        </mat-card-content>
        <div class="bottom-color-border"></div>
      </mat-card>
    </div>
  </div>
</div>
